// extracted by mini-css-extract-plugin
export default {"call_friend__wrapper":"style_call_friend__wrapper__FhmOh","call_friend__panel":"style_call_friend__panel__17rX2","call_friend__reset":"style_call_friend__reset__0MVyc"};